import { useState } from "react"
import { useInternalStore } from "@/src/store"
import { patchWorkspaceInterviewScheduling } from "@/src/services/internal"

import Stack from "@mui/material/Stack"
import Switch from "@mui/material/Switch"
import CircularProgress from "@mui/material/CircularProgress"

type WorkspaceInterviewSchedulingToggleProps = {
    workspaceId: string
    enabled: boolean
}

export function WorkspaceInterviewSchedulingToggle({
    workspaceId,
    enabled,
}: WorkspaceInterviewSchedulingToggleProps) {
    const setWorkspaceInterviewSchedulingEnabled = useInternalStore(
        (state) => state.setWorkspaceInterviewSchedulingEnabled
    )
    const [isUpdating, setIsUpdating] = useState(false)

    const handleToggleChange = async (nextEnabled: boolean) => {
        if (isUpdating) return

        setIsUpdating(true)
        setWorkspaceInterviewSchedulingEnabled(workspaceId, nextEnabled)

        try {
            await patchWorkspaceInterviewScheduling(workspaceId, nextEnabled)
        } catch {
            setWorkspaceInterviewSchedulingEnabled(workspaceId, enabled)
        } finally {
            setIsUpdating(false)
        }
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            onClick={(event) => event.stopPropagation()}
        >
            {isUpdating ? (
                <CircularProgress size={24} />
            ) : (
                <Switch
                    checked={enabled}
                    onChange={(event) => handleToggleChange(event.target.checked)}
                    color="primary"
                    inputProps={{ "aria-label": "Interview scheduling" }}
                />
            )}
        </Stack>
    )
}
